/* eslint-disable id-length */
/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
/* eslint-disable require-unicode-regexp */
export const empty = data => {
  if ( typeof data === 'number' || typeof data === 'boolean' ) {
    return false
  }

  if ( typeof data === 'undefined' || data === null ) {
    return true
  }

  if ( typeof data.length !== 'undefined' ) {
    return data.length === 0
  }

  let count = 0
  for ( const i in data ) {
    if ( data.hasOwnProperty( i ) ) {
      count++
    }
  }

  return count === 0
}

export const isEmptyObject = objeto => {
  if ( !objeto ) {
    return true
  }

  for ( const field in objeto ) {
    if ( objeto.hasOwnProperty( field ) ) {
      if ( !empty( objeto[ field ] ) ) {
        return false
      }
    }
  }

  return true
}

export const sanitizeValue = inputValue => {
  if ( empty( inputValue ) || typeof inputValue.length === 'undefined' ) {
    return ''
  }
  // Remover os seguintes caracteres especiais: '.', '-', '(', ')', '-', ' ', '/', '\', '*'
  const regex = /[.\-*/()_\s]/g
  return inputValue.replace( regex, '' )
}

export const modalidadeSelecionada = modalidade => window.location.href.search( modalidade ) > 0

export const isArray = array => {
  return typeof array !== 'undefined' && array !== null && array.constructor === Array
}

export const isImpar = ( item, index ) => index % 2 === 0

export const isPar = ( item, index ) => index % 2 !== 0

export const isDataVencimentoValida = ( data ) => {
  const mes = parseInt( data.substring( 0, 2 ), 10 ) - 1
  const mesCorrente = new Date().getUTCMonth()
  const ano = 2000 + parseInt( data.substring( 3 ), 10 )
  const anoCorrente = new Date().getUTCFullYear()

  // eslint-disable-next-line no-extra-parens
  if ( ano < anoCorrente || ( ano === anoCorrente && mes < mesCorrente ) ) {
    return false
  }

  return true
}

export const handleKeyPressNumber = ( event ) => {
  const keyCode = event.keyCode || event.which
  const keyValue = String.fromCharCode( keyCode )

  if ( !( /^[0-9]+$/u ).test( keyValue ) && keyCode !== 13 ) {
    return event.preventDefault()
  }
}

export const handleKeyPressRemoveEspaco = event => {
  const keyCode = event.keyCode || event.which
  const keyValue = String.fromCharCode( keyCode )

  if ( ( /\s+/gu ).test( keyValue ) && keyCode !== 13 ) {
    return event.preventDefault()
  }
}

export const handleKeyPressNumerosECaracteresEspeciais = event => {
  const keyCode = event.keyCode || event.which
  const keyValue = String.fromCharCode( keyCode )

  // eslint-disable-next-line no-useless-escape
  if ( ( /[0-9!@#$%^&*¬£¹²³()_+\-=\[\]{};:"\\|,<>\/?]+/g ).test( keyValue ) && keyCode !== 13 ) {
    return event.preventDefault()
  }
}

export const handleKeyPressCaracteresEspeciais = event => {
  const keyCode = event.keyCode || event.which
  const keyValue = String.fromCharCode( keyCode )

  // eslint-disable-next-line no-useless-escape
  if ( ( /[!@#$%^&*¬£¹²³()_+\-=\[\]{};:"\\|,<>\/?]+/g ).test( keyValue ) && keyCode !== 13 ) {
    return event.preventDefault()
  }
}

export const retornarChaveObjeto = objeto => {
  return Object.entries( objeto ).map( campo => {
    const [ chave ] = campo
    return chave
  } )
}

export const capitalizeStrings = string => {
  return string
    .toLowerCase()
    .split( ' ' )
    .map( palavra => palavra.charAt( 0 ).toUpperCase() + palavra.slice( 1 ) )
    .join( ' ' )
}

export const getMesCivil = () => {
  const date = new Date()
  const mesCivil = date.getMonth() + 1
  return mesCivil
}

export const getDiaMes = () => {
  const date = new Date()
  const diaMes = date.getDate()
  return diaMes
}

export const objetoTemPropriedade = ( objeto, propriedade ) => {
  if ( !isEmptyObject( objeto ) ) {
    return Object.prototype.hasOwnProperty.call( objeto, propriedade )
  }

  return false
}

export const goToTop = () => setTimeout( () => window.scroll( 0, 0 ), 0.1 )
